export default __webpack_public_path__ + "media/corona-announcement-subway-hvv-hamburg-63822.7523c390.mp3";